import React, {useState, useEffect} from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import IntegrationWizardStepHeader from "./IntegrationWizardStepHeader.jsx";

const IntegrationWizardStepCountryCode = (props) => {

    const [mRepaint, SetRepaint] = useState(false); //used only as a repainter

    useEffect(() => {
        UpdateNextButtonEnabled()
      }, []); 

    const Repaint = () => {
        SetRepaint(!mRepaint)
    }

    const UpdateNextButtonEnabled = () => {
        const PhoneNumberFieldsConfigured = props.DatasourceTestData.DatasourceFields.filter((field) => field.FieldType === "Phone number").length
        const NameFieldsConfigured = props.DatasourceTestData.DatasourceFields.filter((field) => field.FieldType === "Name").length
        props.OnNextButtonEnabled((PhoneNumberFieldsConfigured > 0) && (NameFieldsConfigured === 1))
    }

    const UpdateFieldType = (value,fieldindex) =>
    {
        props.DatasourceTestData.DatasourceFields[fieldindex].FieldType = value
        Repaint()

        UpdateNextButtonEnabled()
    }  
    
    const PhoneNumberFieldsConfigured = props.DatasourceTestData.DatasourceFields.filter((field) => field.FieldType === "Phone number").length
    const NameFieldsConfigured = props.DatasourceTestData.DatasourceFields.filter((field) => field.FieldType === "Name").length

    return (
        <div>
            <IntegrationWizardStepHeader Header={Translate("Configure your fields")}/>
            
            <table width="100%" cellPadding="50" cellSpacing="0">
            <tbody>
            <tr>
                <td className="wizardoutercell">

                    {PhoneNumberFieldsConfigured < 1 ? <div className="errortext">{Translate("At least one phone number field is required")}</div> : <></>}
                    {NameFieldsConfigured < 1 ? <div className="errortext">{Translate("A name field is required")}</div> : <></>}
                    {NameFieldsConfigured > 1 ? <div className="errortext">{Translate("Cannot have more than one name field")}</div> : <></>}

                    {(PhoneNumberFieldsConfigured > 0) && (NameFieldsConfigured === 1) ? <div style={{ color: "green"}}>{Translate("Configuration OK")}</div> : <></>}

                    <br/>

                    <table>
                    <tbody>
                        <tr>
                            {props.DatasourceTestData.DatasourceFields.map((field,index) => <th style={{width: "150px"}}>
                                {field.FieldLabel}<br/>
                                <select style={{ width: "146px", borderRadius: "0px", borderWidth: "1px", padding: "3px"}} onChange={evt => UpdateFieldType(evt.target.value, index)}>
                                    <option value="Phone number" selected={field.FieldType === "Phone number"}>{Translate("Phone number")}</option>
                                    <option value="Name" selected={field.FieldType === "Name"}>{Translate("Name")}</option>
                                    <option value="Organization" selected={field.FieldType === "Organization"}>{Translate("Organization")}</option>
                                    <option value="Email" selected={field.FieldType === "Email"}>{Translate("Email")}</option>
                                    <option value="Address" selected={field.FieldType === "Address"}>{Translate("Address")}</option>
                                    <option value="City" selected={field.FieldType === "City"}>{Translate("City")}</option>
                                    <option value="Country" selected={field.FieldType === "Country"}>{Translate("Country")}</option>
                                    <option value="Uri" selected={field.FieldType === "Uri"}>URL</option>
                                    <option value="Destination" selected={field.FieldType === "Destination"}>{Translate("Destination")}</option>
                                    <option value="Custom field" selected={field.FieldType === "Custom field"}>{Translate("Custom field")}</option>
                                </select>  
                            </th>)}
                        </tr>
                        {props.DatasourceTestData.DatasourceRows.map((row) => 
                            <tr>
                                {row.map((rowitem) => <td>{rowitem}</td>)}
                            </tr>
                        )}
                    </tbody>
                    </table>
                </td>
            </tr>
            </tbody>
            </table> 
        </div>
    )
}

IntegrationWizardStepCountryCode.propTypes = {
    IntegrationSettings: PropTypes.object,
    DatasourceTestData: PropTypes.object,
    OnNextButtonEnabled: PropTypes.func
}
               
export default IntegrationWizardStepCountryCode